/* eslint-disable */

export default {
  slider() {
    import(/* webpackChunkName: "slick" */ './lib/slick').then(() => {
      $('.js-hero-slider').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'linear',
        fade: true,
        infinite: true,
        speed: 500
      });
    });
  }
};
